import { render, staticRenderFns } from "./SVGParangonHistory.vue?vue&type=template&id=838fe8f4&scoped=true&"
import script from "./SVGParangonHistory.vue?vue&type=script&lang=js&"
export * from "./SVGParangonHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838fe8f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
